import { FC } from 'react';
import { DefaultOptionType, SelectProps } from 'antd/lib/select';
import TagsListSelector from 'components/molecules/TagsListSelector';
import TagList from 'components/molecules/TagsList';
import { CustomSensorModel } from 'components/pages/AssetPage/Tabs/TabConsumption/OptionList/resources/models';
import './styles.scss';

interface TagsListManagerProps {
  sensor: CustomSensorModel;
  tagList: string[];
  temporalTagList: string[];
  emptyTagListText: string;
  placeholder: string;
  saveButtonText: string;
  cancelButtonText: string;
  availableTags: DefaultOptionType[];
  selectMode?: SelectProps['mode'];
  onSave: (sensor: CustomSensorModel, newTags: string[]) => void;
  onChangeTagList: (values: string[] | null) => void;
  onCloseTagEditor: () => void;
  onFilterTagList: (input: string, option?: DefaultOptionType) => boolean;
  isSavingTagsList: boolean;
  allowClear?: boolean;
}

const TagsListManager: FC<TagsListManagerProps> = ({
  sensor,
  tagList,
  temporalTagList,
  emptyTagListText,
  placeholder,
  saveButtonText,
  cancelButtonText,
  availableTags,
  selectMode,
  onSave,
  onCloseTagEditor,
  onChangeTagList,
  onFilterTagList,
  isSavingTagsList,
  allowClear,
}) => {
  const { isEditingTagList } = sensor;

  return (
    <>
      {!isEditingTagList && !!tagList.length && <TagList tagList={tagList} />}
      {!isEditingTagList && !tagList.length && <span className={'TagListManager__empty'}>{emptyTagListText}</span>}
      {isEditingTagList && (
        <TagsListSelector
          sensor={sensor}
          selectedTags={temporalTagList}
          placeholder={placeholder}
          saveButtonText={saveButtonText}
          cancelButtonText={cancelButtonText}
          availableTags={availableTags}
          selectMode={selectMode}
          onSaveTags={onSave}
          onChangeTags={onChangeTagList}
          onCloseTags={onCloseTagEditor}
          onFilterTags={onFilterTagList}
          isSavingTagsList={isSavingTagsList}
          allowClear={allowClear}
        />
      )}
    </>
  );
};

export default TagsListManager;